import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import moment from "moment";
import ButtonForAll from "../../components/common/Button";
import {
  convertToWords,
  formatIndianNumber,
  // getLocalStorageItem,
} from "../../_helper/helper";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import {
  clearMarginRateList,
  clearRetailerSalesOrderDetails,
} from "./retailerSalesOrderSlice";
import {
  createRetailerSalesOrder,
  getAllRetailerMarginRates,
  getRetailerSalesOrderByID,
  updateRetailerSalesOrder,
} from "./services/retailerSalesOrder.services";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormDatePicker from "../../components/formFields/FormDateField";
import {
  getAllDistributorWiseRetailerIncremental,
  // getAllRetailerIncremental,
} from "../retailer/services/retailer.services";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  ExpansionPanelContent,
} from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import FormMultiSelectionFiled from "../../components/formFields/FormMultiSelectionFiled";
import { getAllSchemes } from "../scheme/services/scheme.services";
import { IScheme } from "../scheme/schemeModel";
// import FormIncrementalSearch from "../../components/formFields/FormIncrementalSearch";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextArea from "../../components/formFields/FormTextArea";
import { FINANCIAL_YEAR } from "../../_contstants/common";
import { sumBy } from "lodash";
import FormSelectionField from "../../components/formFields/FormSelectionField";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const OrderChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const UserTypeIDString = useAppSelector(
    (state) => state.login.loginDetails.UserTypeID
  );
  const UserTypeID = parseInt(UserTypeIDString);
  const location = useLocation();
  const id = location.state?.id;
  const date = location.state?.date;
  const retailer_options = location.state?.retailer_options;
  const distributor_id = isNaN(Number(localStorage.getItem("AccountID")))
    ? null
    : Number(localStorage.getItem("AccountID"));

  const dispatch = useAppDispatch();

  const fetchData = async () => {
    const payload = {
      distributor_id: distributor_id,
      retailer_name: "",
    };
    const result = await dispatch(
      getAllDistributorWiseRetailerIncremental(payload)
    );
    formRenderProps.onChange("retailer_options", {
      value: result.payload,
    });
  };
  useEffect(() => {
    if (distributor_id) {
      fetchData();
    }
  }, [distributor_id]);

  useEffect(() => {
    if (UserTypeID === 5 && !id) {
      formRenderProps.onChange("retailer_options", {
        value:
          retailer_options && retailer_options?.length > 0
            ? retailer_options
            : [],
      });
      formRenderProps.onChange("retailerid", {
        value:
          retailer_options && retailer_options?.length > 0
            ? retailer_options[0]?.retailer_id
            : null,
      });
      formRenderProps.onChange("date", {
        value: date ? moment(date, "DD/MM/YYYY")?.toDate() : "",
      });
    }
  }, [UserTypeID]);

  return null;
};

const CreateRetailerSalesOrder: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;
  const sr_retailer_id = location.state?.sr_retailer_id;
  const distributor_id = location.state?.distributor_id;
  // const isView = location.state?.isView;
  const date = location.state?.date;
  const gridRef = React.useRef<any>(null);

  const AccountIDString = useAppSelector(
    (state) => state.login.loginDetails.AccountID
  );
  const StateIDString = useAppSelector(
    (state) => state.login.loginDetails.StateID
  );
  const UserIDString = useAppSelector(
    (state) => state.login.loginDetails.UserID
  );
  const UserTypeIDString = useAppSelector(
    (state) => state.login.loginDetails.UserTypeID
  );
  const AccountID = parseInt(AccountIDString);
  const StateID = parseInt(StateIDString);
  const UserID = parseInt(UserIDString);
  const UserTypeID = parseInt(UserTypeIDString);

  const loading = useAppSelector((state) => state.retailerSalesOrder.loading);
  const MarginRateList = useAppSelector(
    (state) => state.retailerSalesOrder.MarginRateList
  );
  const SchemeList = useAppSelector((state) => state.scheme.SchemeList);
  const RetailerSalesOrderDetail = useAppSelector(
    (state) => state.retailerSalesOrder.RetailerSalesOrderDetail
  );

  const [initialValues, setInitialValues] = useState({});
  const [formKey, setFormKey] = useState(1);
  const [showPrint, setShowPrint] = useState(false);
  const [submitAction, setSubmitAction] = useState("value");
  const [printData, setPrintData] = useState([]);
  const [RateData, setRateData] = useState<any[]>(
    JSON.parse(JSON.stringify(MarginRateList))
  );

  const [expanded, setExpanded] = React.useState<any>(0);

  useEffect(() => {
    dispatch(getAllRetailerMarginRates(false));
    dispatch(getAllSchemes());
  }, []);

  useEffect(() => {
    dispatch(clearRetailerSalesOrderDetails());
    setInitialValues({});

    return () => {
      dispatch(clearMarginRateList());
      dispatch(clearRetailerSalesOrderDetails());
      setRateData([]);
    };
  }, [location?.pathname]);

  useEffect(() => {
    if (id) {
      dispatch(getRetailerSalesOrderByID(+id));
    }
  }, [id]);

  // useEffect(() => {
  //   const updatedValue: any = RateData?.map((item: any) => ({
  //     ...item,
  //     item_margin_rate: item?.item_margin_rate?.filter(
  //       (subItem: any) => subItem.quantity > 0
  //     ),
  //   }))?.filter((item: any) => item?.item_margin_rate?.length > 0);

  //   setPrintData(updatedValue);
  //   if (isView) {
  //     setShowPrint(true);
  //   }
  // }, [RateData]);

  useEffect(() => {
    const updatedMarginRatelist = JSON.parse(JSON.stringify(MarginRateList));
    const updatedData = updatedMarginRatelist.map((itemGroup: any) => {
      const updatedItems = itemGroup.item_margin_rate.map((item: any) => {
        RetailerSalesOrderDetail?.retailer_sales?.forEach((printGroup: any) => {
          if (item.item_group_id === printGroup.item_group_id) {
            printGroup.retailer_sales_order_list.forEach((printItem: any) => {
              if (item.item_id === printItem.item_id) {
                item.quantity = +printItem.quantity;
                item.free_qty = +printItem.free_qty;
                item.amount = +printItem.amount;
                item.rate = +printItem.rate;
                item.id = +printItem.id;
              }
            });
          }
        });
        return item;
      });
      return {
        ...itemGroup,
        item_margin_rate: updatedItems,
      };
    });

    setRateData(updatedData);
  }, [MarginRateList, RetailerSalesOrderDetail]);

  useEffect(() => {
    const newInitialValues =
      RetailerSalesOrderDetail &&
      RetailerSalesOrderDetail?.retailer_sales &&
      RetailerSalesOrderDetail?.retailer_sales
        ?.map((item: any) => {
          return item?.retailer_sales_order_list?.map((subitem: any) => {
            return {
              [`qty_${item?.item_group_id}_${subitem?.item_id}`]:
                subitem?.quantity,
              [`free_qty_${item?.item_group_id}_${subitem?.item_id}`]:
                subitem?.free_qty,
              [`amount_${item?.item_group_id}_${subitem?.item_id}`]:
                subitem?.amount,
              [`rate_${item?.item_group_id}_${subitem?.item_id}`]:
                subitem?.rate,
            };
          });
        })
        ?.reduce((acc: any, curr: any) => {
          return {
            ...RetailerSalesOrderDetail,
            ...acc,
            ...curr.reduce((subAcc: any, subCurr: any) => {
              return { ...subAcc, ...subCurr };
            }, {}),
          };
        }, {});

    if (JSON.stringify(newInitialValues) !== JSON.stringify(initialValues)) {
      setInitialValues(newInitialValues);
      setFormKey((prevKey) => prevKey + 1);
    }
  }, [RetailerSalesOrderDetail]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, []);

  const handleQtyChange = (
    formRenderProps: FormRenderProps,
    mainIndex: number,
    subIndex: number,
    itemGroupId: number,
    itemId: number
  ) => {
    const qty = formRenderProps.valueGetter(`qty_${itemGroupId}_${itemId}`);
    const free_qty = formRenderProps.valueGetter(
      `free_qty_${itemGroupId}_${itemId}`
    );
    const rate = formRenderProps.valueGetter(`rate_${itemGroupId}_${itemId}`)
      ? formRenderProps.valueGetter(`rate_${itemGroupId}_${itemId}`)
      : RateData[mainIndex]?.item_margin_rate[subIndex]?.rate;
    // const rate = RateData[mainIndex]?.item_margin_rate[subIndex]?.rate;
    if (qty === 0) {
      formRenderProps.onChange(`qty_${itemGroupId}_${itemId}`, {
        value: null,
      });
    }
    if (free_qty === 0) {
      formRenderProps.onChange(`free_qty_${itemGroupId}_${itemId}`, {
        value: null,
      });
    }

    formRenderProps.onChange(`amount_${itemGroupId}_${itemId}`, {
      value: +rate * +qty || null,
    });

    RateData[mainIndex].item_margin_rate[subIndex].amount = +rate * +qty || 0;
    RateData[mainIndex].item_margin_rate[subIndex].quantity = +qty || 0;
    RateData[mainIndex].item_margin_rate[subIndex].free_qty = +free_qty || 0;
    RateData[mainIndex].item_margin_rate[subIndex].rate = +rate || 0;

    const groupsWiseTotal = RateData.map((group: any) => ({
      [group.item_group_id]: sumBy(group.item_margin_rate, "amount") || 0,
    }));
    const grandTotal = sumBy(
      groupsWiseTotal,
      (group: any) => Object.values(group)[0] as number
    );
    formRenderProps.onChange(`total_amount`, {
      value: grandTotal || 0,
    });
  };

  const handlePrevious = () => {
    setShowPrint(!showPrint);
    RateData.forEach((itemGroup) => {
      itemGroup.item_margin_rate.forEach((item: any) => {
        printData.forEach((printGroup: any) => {
          if (item.item_group_id === printGroup.item_group_id) {
            printGroup.item_margin_rate.forEach((printItem: any) => {
              if (item.item_id === printItem.item_id) {
                item.quantity = printItem.quantity;
                item.free_qty = printItem.free_qty;
                item.amount = printItem.amount;
              }
            });
          }
        });
      });
    });
  };

  // const handlRetailerSearchChange = React.useCallback(
  //   async (search: string, field: string, formRenderProps: FormRenderProps) => {
  //     if (search.length >= 3) {
  //       const payload = {
  //         distributor_id: isNaN(Number(localStorage.getItem("AccountID")))
  //           ? null
  //           : Number(localStorage.getItem("AccountID")),
  //         retailer_name: search,
  //       };
  //       const result = await dispatch(
  //         getAllDistributorWiseRetailerIncremental(payload)
  //       );
  //       formRenderProps.onChange(field, {
  //         value: result.payload,
  //       });
  //     }
  //   },
  //   [dispatch]
  // );

  const handleSubmit = async (values: any) => {
    if (submitAction === "value") {
      const updatedValue: any = RateData?.map((item: any) => ({
        ...item,
        item_margin_rate: item?.item_margin_rate?.filter(
          (subItem: any) => subItem.quantity > 0 || subItem?.free_qty > 0
        ),
      }))?.filter((item: any) => item?.item_margin_rate?.length > 0);

      setPrintData(updatedValue);
      setShowPrint(!showPrint);
    } else {
      const place_order_items =
        printData &&
        printData.length > 0 &&
        printData?.flatMap(
          (salesorderitem: any) =>
            salesorderitem?.item_margin_rate &&
            salesorderitem?.item_margin_rate.length > 0 &&
            salesorderitem?.item_margin_rate?.map((item: any) => {
              return {
                id: item?.id ? +item?.id : 0,
                item_id: item?.item_id ? +item?.item_id : null,
                // item_group_id: item?.item_group_id
                //   ? +item?.item_group_id
                //   : null,
                mrp: item?.mrp ? +item?.mrp : null,
                quantity: item?.quantity ? +item?.quantity : null,
                free_qty: item?.free_qty ? +item?.free_qty : null,
                unit_id: item?.unit_id ? +item?.unit_id : null,
                rate: item?.rate ? +item?.rate : null,
                // gst_id: item?.gst_id ? +item?.gst_id : null,
                total_amount: item?.amount ? +item?.amount : null,
              };
            })
        );

      if (id) {
        const editPayload: any = {
          id: id ? +id : null,
          sr_retailer_id:
            UserTypeID === 5
              ? values?.sr_retailer_id
                ? +values?.sr_retailer_id
                : null
              : null,
          scheme: values?.scheme ? values?.scheme?.join(", ") : "",
          retailerid: values?.retailerid ? +values?.retailerid : null,
          date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : "",
          financial_year: FINANCIAL_YEAR,
          remarks:
            UserTypeID === 5 ? (values?.remarks ? values?.remarks : "") : "",
          retailer_sales_order_list: place_order_items || [],
          total_amount: values?.total_amount
            ? +values?.total_amount?.toFixed(2)
            : 0,
        };

        const response = await dispatch(updateRetailerSalesOrder(editPayload));
        if (response.meta.requestStatus === "fulfilled") {
          navigate(-1);
        }
      } else {
        const insertPayload: any = {
          sr_retailer_id:
            UserTypeID === 5 ? (sr_retailer_id ? +sr_retailer_id : null) : null,
          retailerid: values?.retailerid ? +values?.retailerid : null,
          scheme: values?.scheme ? values?.scheme?.join(", ") : "",
          date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : "",
          financial_year: FINANCIAL_YEAR,
          remarks:
            UserTypeID === 5 ? (values?.remarks ? values?.remarks : "") : "",
          retailer_sales_order_list: place_order_items || [],
          total_amount: values?.total_amount
            ? +values?.total_amount?.toFixed(2)
            : 0,
        };

        const response = await dispatch(
          createRetailerSalesOrder(insertPayload)
        );
        if (response.meta.requestStatus === "fulfilled") {
          if (UserTypeID === 5) {
            navigate("/distributororder/compititor/add", {
              state: {
                sr_retailer_id: sr_retailer_id ? +sr_retailer_id : null,
                distributor_id: distributor_id ? +distributor_id : null,
                sr_id: UserID ? +UserID : null,
                date: date ? moment(date).format("YYYY-MM-DD") : "",
              },
            });
          } else {
            navigate(-1);
          }
        }
      }
    }
  };

  let totalAmount = 0;
  let totalAmountGST5 = 0;
  let totalAmountGST12 = 0;
  let totalAmountGST18 = 0;
  let totalAmountGST28 = 0;
  let totalGST5 = 0;
  let totalGST12 = 0;
  let totalGST18 = 0;
  let totalGST28 = 0;

  printData &&
    printData.length > 0 &&
    printData?.map(
      (salesorderitem: any) =>
        salesorderitem?.item_margin_rate &&
        salesorderitem?.item_margin_rate.length > 0 &&
        salesorderitem?.item_margin_rate?.map((item: any) => {
          totalAmount += item?.amount;
          if (item?.gst === 5) {
            totalGST5 += (item?.amount * item?.gst) / 100;
            totalAmountGST5 += item?.amount;
          }
          if (item?.gst === 12) {
            totalGST12 += (item?.amount * item?.gst) / 100;
            totalAmountGST12 += item?.amount;
          }
          if (item?.gst === 18) {
            totalGST18 += (item?.amount * item?.gst) / 100;
            totalAmountGST18 += item?.amount;
          }
          if (item?.gst === 28) {
            totalGST28 += (item?.amount * item?.gst) / 100;
            totalAmountGST28 += item?.amount;
          }
        })
    );
  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <div className={`${AccountID ? "container p-2" : ""}`}>
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement
            style={{
              overflow: "scroll",
              scrollbarWidth: "none",
              boxShadow: "lightgray 0px 0px 10px",
              borderRadius: 10,
              background: "white",
            }}
          >
            {!showPrint ? (
              <ShadowCard style={{ padding: 12, marginBottom: 10 }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4>
                      {id
                        ? "Update Retailer Sales Order"
                        : "Add Retailer Sales Order"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    className="row"
                    style={{ marginRight: "5px" }}
                  >
                    <div className="col-md-4 pe-md-0">
                      <Field
                        name="retailerid"
                        label="Retailer Name"
                        placeholder="Select Retailer"
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        disabled={UserTypeID === 5}
                        // fetchIncrementalData={(search: any) =>
                        //   handlRetailerSearchChange(
                        //     search,
                        //     `retailer_options`,
                        //     formRenderProps
                        //   )
                        // }
                        options={
                          formRenderProps
                            .valueGetter("retailer_options")
                            ?.map((item: any) => {
                              return {
                                value: item.retailer_id,
                                label: `${item.retailer_name} - ${item.area_name}`,
                              };
                            }) || []
                        }
                      />
                    </div>
                    <div className="col-md-4 pe-md-0">
                      <Field
                        name="date"
                        label="Date"
                        disabled={UserTypeID === 5}
                        component={FormDatePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </div>
                    <div className="col-md-4 pe-md-0">
                      <Field
                        name="scheme"
                        label="Scheme"
                        placeholder="Scheme"
                        component={FormMultiSelectionFiled}
                        options={SchemeList?.map((scheme: IScheme) => {
                          return {
                            value: scheme?.id,
                            label: scheme?.scheme_name,
                          };
                        })}
                      />
                    </div>
                  </GridLayoutItem>
                  {UserTypeID === 5 && (
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name="remarks"
                        label="Remarks"
                        placeholder="Remarks"
                        rows={2}
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                  )}
                  <GridLayoutItem
                    colSpan={3}
                    style={{ overflow: "scroll", scrollbarWidth: "none" }}
                  >
                    <div
                      className="container-fluid orderform"
                      style={{ padding: "20px 0 0 0", minWidth: 800 }}
                    >
                      <div className="row">
                        <div className="col-12">
                          <table
                            cellSpacing={1}
                            cellPadding={2}
                            className="table table-bordered w-100  salesorder-print-table"
                            style={{ marginTop: 1 }}
                          >
                            <tr
                              className="text-center fw-600 text-white bg-dark"
                              style={{ fontSize: 12 }}
                            >
                              <th className="pb-3 pt-3" style={{ width: "5%" }}>
                                No.
                              </th>
                              <th style={{ width: "35%" }}>
                                Description Of Goods
                              </th>
                              <th style={{ width: "10%" }}>MRP</th>
                              <th
                                colSpan={2}
                                style={{ width: "20%", minWidth: 110 }}
                              >
                                Quantity / Per
                              </th>
                              <th style={{ width: "10%", minWidth: 110 }}>
                                Free Qty.
                              </th>
                              {/* <th style={{ width: "10%" }}>Per</th> */}
                              <th style={{ width: "10%", minWidth: 150 }}>
                                Rate
                              </th>
                              <th style={{ width: "10%", minWidth: 150 }}>
                                Amount
                              </th>
                            </tr>
                            {RateData && RateData.length > 0 ? (
                              RateData?.map((item: any, mainIndex: number) => (
                                <tr key={mainIndex}>
                                  <td colSpan={8} className="p-0">
                                    <ExpansionPanel
                                      title={item?.item_group}
                                      expanded={expanded === mainIndex}
                                      tabIndex={0}
                                      key={item.id}
                                      onAction={(
                                        event: ExpansionPanelActionEvent
                                      ) => {
                                        setExpanded(
                                          event.expanded ? null : mainIndex
                                        );
                                      }}
                                    >
                                      <Reveal>
                                        {expanded === mainIndex && (
                                          <ExpansionPanelContent className="sales-order-hover-class">
                                            {item?.item_margin_rate &&
                                              item?.item_margin_rate?.length >
                                                0 &&
                                              item?.item_margin_rate?.map(
                                                (
                                                  subitem: any,
                                                  subIndex: number
                                                ) => (
                                                  <div
                                                    key={subIndex}
                                                    id={`collapse${mainIndex}`}
                                                    // className={`accordion-collapse collapse ${
                                                    //   mainIndex === 0
                                                    //     ? "show"
                                                    //     : ""
                                                    // }`}
                                                    // data-bs-parent="#accordionExample"
                                                  >
                                                    <div
                                                      // className="accordion-body"
                                                      style={{
                                                        padding: "5px 0",
                                                      }}
                                                    >
                                                      <table
                                                        style={{
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <tr>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                            }}
                                                            className="text-center"
                                                          >
                                                            {subIndex + 1}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "35%",
                                                            }}
                                                          >
                                                            {
                                                              subitem?.product_name
                                                            }
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "10%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            Rs.{" "}
                                                            {subitem?.mrp || 0}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "10%",
                                                              minWidth: 110,
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`qty_${item?.item_group_id}_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  item?.item_group_id,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              // format="n2"
                                                              format={
                                                                subitem?.unit_decimal &&
                                                                subitem?.unit_decimal >
                                                                  0
                                                                  ? `n${subitem?.unit_decimal}`
                                                                  : "n0"
                                                              }
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "10%",
                                                            }}
                                                          >
                                                            {subitem?.unit_code}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "10%",
                                                              minWidth: 110,
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`free_qty_${item?.item_group_id}_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  item?.item_group_id,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              // format="n2"
                                                              format={
                                                                subitem?.unit_decimal &&
                                                                subitem?.unit_decimal >
                                                                  0
                                                                  ? `n${subitem?.unit_decimal}`
                                                                  : "n0"
                                                              }
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "10%",
                                                              textAlign:
                                                                "center",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "5px",
                                                              minWidth: 150,
                                                            }}
                                                          >
                                                            Rs.{" "}
                                                            <Field
                                                              wrapperClassName="right-alighned-field orderform-amount"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  item?.item_group_id,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              defaultValue={
                                                                formRenderProps.valueGetter(
                                                                  `rate_${item?.item_group_id}_${subitem?.item_id}`
                                                                )
                                                                  ? formRenderProps.valueGetter(
                                                                      `rate_${item?.item_group_id}_${subitem?.item_id}`
                                                                    )
                                                                  : subitem?.rate
                                                              }
                                                              name={`rate_${item?.item_group_id}_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              format="n2"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                            />
                                                            {/* {subitem?.rate || 0} */}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "10%",
                                                              padding: "0 5px",
                                                              minWidth: 150,
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field orderform-amount"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`amount_${item?.item_group_id}_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              format="n2"
                                                              disabled={true}
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                            />
                                                          </td>
                                                        </tr>
                                                      </table>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </ExpansionPanelContent>
                                        )}
                                      </Reveal>
                                    </ExpansionPanel>
                                    {/* <div
                                      className="accordion p-0 "
                                      id="accordionExample"
                                    >
                                      <div
                                        className="accordion-item"
                                        style={{ borderTop: 0 }}
                                      >
                                        <h2 className="accordion-header">
                                          <button
                                            className={`accordion-button ${
                                              mainIndex === 0 ? "" : "collapsed"
                                            }`}
                                            style={{ borderRadius: 0 }}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${mainIndex}`}
                                            aria-expanded={
                                              mainIndex === 0 ? "true" : "false"
                                            }
                                            aria-controls={`collapse${mainIndex}`}
                                          >
                                            <div
                                              className="fw-600"
                                              style={{ fontSize: 12 }}
                                            >
                                              {item?.item_group}
                                            </div>
                                          </button>
                                        </h2>
                                        {item?.item_margin_rate &&
                                          item?.item_margin_rate?.length > 0 &&
                                          item?.item_margin_rate?.map(
                                            (
                                              subitem: any,
                                              subIndex: number
                                            ) => (
                                              <div
                                                key={subIndex}
                                                id={`collapse${mainIndex}`}
                                                className={`accordion-collapse collapse ${
                                                  mainIndex === 0 ? "show" : ""
                                                }`}
                                                data-bs-parent="#accordionExample"
                                              >
                                                <div
                                                  className="accordion-body"
                                                  style={{ padding: "10px 0" }}
                                                >
                                                  <table
                                                    style={{ width: "100%" }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{ width: "5%" }}
                                                        className="text-center"
                                                      >
                                                        {subIndex + 1}
                                                      </td>
                                                      <td
                                                        style={{ width: "45%" }}
                                                      >
                                                        {subitem?.product_name}
                                                      </td>
                                                      <td
                                                        style={{
                                                          width: "10%",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        Rs. {subitem?.mrp || 0}
                                                      </td>
                                                      <td
                                                        style={{ width: "10%" }}
                                                      >
                                                        <Field
                                                          wrapperClassName="right-alighned-field"
                                                          wrapperStyle={{
                                                            margin: 0,
                                                          }}
                                                          name={`qty_${item?.item_group_id}_${subitem?.item_id}`}
                                                          placeholder="0"
                                                          onChange={() =>
                                                            handleQtyChange(
                                                              formRenderProps,
                                                              mainIndex,
                                                              subIndex,
                                                              item?.item_group_id,
                                                              subitem?.item_id
                                                            )
                                                          }
                                                          format="n2"
                                                          component={
                                                            FormNumericTextField
                                                          }
                                                        />
                                                      </td>
                                                      <td
                                                        style={{
                                                          width: "10%",
                                                        }}
                                                      >
                                                        {subitem?.unit_name}
                                                      </td>
                                                      <td
                                                        style={{
                                                          width: "10%",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        Rs. {subitem?.rate || 0}
                                                      </td>
                                                      <td
                                                        style={{
                                                          width: "10%",
                                                          padding: "0 5px",
                                                        }}
                                                      >
                                                        <Field
                                                          wrapperClassName="right-alighned-field orderform-amount"
                                                          wrapperStyle={{
                                                            margin: 0,
                                                          }}
                                                          name={`amount_${item?.item_group_id}_${subitem?.item_id}`}
                                                          placeholder="0"
                                                          format="n2"
                                                          disabled={true}
                                                          component={
                                                            FormNumericTextField
                                                          }
                                                        />
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </div>
                                    </div> */}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={8} className="text-center p-2">
                                  No Records Found
                                </td>
                              </tr>
                            )}
                          </table>
                        </div>
                        <div>
                          <Typography.p
                            className="text-end mt-3"
                            style={{ fontSize: "18px", fontWeight: "bold" }}
                          >
                            Total Amount :{" "}
                            <span style={{ color: "green" }}>
                              {" "}
                              {formRenderProps
                                .valueGetter("total_amount")
                                ?.toFixed(2) || 0.0}
                            </span>
                          </Typography.p>
                        </div>
                        <div
                          className="col-12"
                          style={{
                            textAlign: "end",
                            marginTop: "20px",
                            width: "100%",
                          }}
                        >
                          <ButtonForAll
                            label="Verify"
                            type="submit"
                            onClick={() => setSubmitAction("value")}
                            disabled={
                              !formRenderProps.allowSubmit
                              // || loading
                            }
                            // loading={loading}
                          />
                          <Button
                            type="button"
                            fillMode={"outline"}
                            themeColor={"primary"}
                            style={{ marginLeft: 4 }}
                            onClick={() => navigate(-1)}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            ) : (
              <div
                className="order-container"
                style={{ padding: 12, minWidth: 800 }}
              >
                <div className="row">
                  <div className="col-12">
                    <Typography.h4 className="text-center">
                      Retailer Sales Order
                    </Typography.h4>
                  </div>
                  <div className="col-12 order-print-page">
                    {UserTypeID === 5 ? (
                      <table
                        cellSpacing={1}
                        cellPadding={2}
                        className="table table-bordered w-100  order-print-table mb-0"
                        style={{ marginTop: 1 }}
                      >
                        <tr
                          className="text-center fw-600"
                          style={{ fontSize: 12 }}
                        >
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Sr No.
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "30%" }}
                          >
                            Description Of Goods
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            MRP
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Quantity
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Free Qty.
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Per
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Rate
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Amount
                          </th>
                        </tr>
                        {printData &&
                          printData?.length > 0 &&
                          printData?.map((item: any) => (
                            <>
                              <tr>
                                <td
                                  className="fw-600"
                                  colSpan={7}
                                  style={{ fontSize: 12 }}
                                >
                                  {item?.item_group}
                                </td>
                              </tr>
                              {item?.item_margin_rate &&
                                item?.item_margin_rate?.length > 0 &&
                                item?.item_margin_rate?.map(
                                  (subitem: any, index: number) => (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{subitem?.product_name}</td>
                                      <td>Rs. {subitem?.mrp || 0}</td>
                                      <td className="text-end">
                                        {subitem?.quantity}
                                      </td>
                                      <td className="text-end">
                                        {subitem?.free_qty}
                                      </td>
                                      <td>{subitem?.unit_name}</td>
                                      <td>
                                        Rs.{" "}
                                        {formatIndianNumber(subitem?.rate) || 0}
                                      </td>
                                      <td className=" text-end fw-500">
                                        {formatIndianNumber(subitem?.amount)}
                                      </td>
                                    </tr>
                                  )
                                )}
                            </>
                          ))}
                        <tr style={{ background: "whitesmoke" }}>
                          <td colSpan={7} className="text-end fw-600">
                            Grand Total
                          </td>
                          <td
                            className="text-end fw-600"
                            style={{ fontSize: 14 }}
                          >
                            {formatIndianNumber(totalAmount)}
                          </td>
                        </tr>
                      </table>
                    ) : (
                      <table
                        cellSpacing={1}
                        cellPadding={2}
                        className="table table-bordered w-100  order-print-table mb-0"
                        style={{ marginTop: 1 }}
                      >
                        <tr
                          className="text-center fw-600"
                          style={{ fontSize: 12 }}
                        >
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Sr No.
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "30%" }}
                          >
                            Description Of Goods
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            MRP
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Quantity
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Free Qty
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Per
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Rate
                          </th>
                          <th
                            className="order-print-th"
                            style={{ width: "10%" }}
                          >
                            Amount
                          </th>
                        </tr>
                        {printData &&
                          printData?.length > 0 &&
                          printData?.map((item: any) => (
                            <>
                              <tr>
                                <td
                                  className="fw-600"
                                  colSpan={8}
                                  style={{ fontSize: 12 }}
                                >
                                  {item?.item_group}
                                </td>
                              </tr>
                              {item?.item_margin_rate &&
                                item?.item_margin_rate?.length > 0 &&
                                item?.item_margin_rate?.map(
                                  (subitem: any, index: number) => (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{subitem?.product_name}</td>
                                      <td>Rs. {subitem?.mrp || 0}</td>
                                      <td className="text-end">
                                        {subitem?.quantity}
                                      </td>
                                      <td className="text-end">
                                        {subitem?.free_qty}
                                      </td>
                                      <td>{subitem?.unit_name}</td>
                                      <td>
                                        Rs.{" "}
                                        {formatIndianNumber(subitem?.rate) || 0}
                                      </td>
                                      <td className=" text-end fw-500">
                                        {formatIndianNumber(subitem?.amount)}
                                      </td>
                                    </tr>
                                  )
                                )}
                            </>
                          ))}
                        <tr>
                          <td colSpan={7}></td>
                          <td
                            className="text-end fw-600"
                            style={{ fontSize: 14 }}
                          >
                            {formatIndianNumber(totalAmount)}
                          </td>
                        </tr>
                        {StateID === 1 ? (
                          <>
                            {totalGST5 > 0 && (
                              <>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">CGST 2.5%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">2.5</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST5 / 2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">SGST 2.5%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">2.5</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST5 / 2)}
                                  </td>
                                </tr>
                              </>
                            )}
                            {totalGST12 > 0 && (
                              <>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">CGST 6%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">6</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST12 / 2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">SGST 6%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">6</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST12 / 2)}
                                  </td>
                                </tr>
                              </>
                            )}
                            {totalGST18 > 0 && (
                              <>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">CGST 9%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">9</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST18 / 2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">SGST 9%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">9</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST18 / 2)}
                                  </td>
                                </tr>
                              </>
                            )}
                            {totalGST28 > 0 && (
                              <>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">CGST 14%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">14</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST28 / 2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td className=" text-end">SGST 14%</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td className=" text-end">14</td>
                                  <td>%</td>
                                  <td className=" text-end fw-500">
                                    {formatIndianNumber(+totalGST28 / 2)}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {totalGST5 > 0 && (
                              <tr>
                                <td></td>
                                <td className=" text-end">IGST 5%</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className=" text-end">5</td>
                                <td>%</td>
                                <td className=" text-end fw-500">
                                  {formatIndianNumber(+totalGST5)}
                                </td>
                              </tr>
                            )}
                            {totalGST12 > 0 && (
                              <tr>
                                <td></td>
                                <td className=" text-end">IGST 12%</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className=" text-end">12</td>
                                <td>%</td>
                                <td className=" text-end fw-500">
                                  {formatIndianNumber(+totalGST12)}
                                </td>
                              </tr>
                            )}
                            {totalGST18 > 0 && (
                              <tr>
                                <td></td>
                                <td className=" text-end">IGST 18%</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className=" text-end">18</td>
                                <td>%</td>
                                <td className=" text-end fw-500">
                                  {formatIndianNumber(+totalGST18)}
                                </td>
                              </tr>
                            )}
                            {totalGST28 > 0 && (
                              <tr>
                                <td></td>
                                <td className=" text-end">IGST 28%</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className=" text-end">28</td>
                                <td>%</td>
                                <td className=" text-end fw-500">
                                  {formatIndianNumber(+totalGST28)}
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                        <tr style={{ fontSize: 12 }}>
                          <td
                            colSpan={7}
                            className=" text-end fw-600"
                            style={{ fontSize: 14 }}
                          >
                            {" "}
                            Total Invoice Amount:
                          </td>
                          <td
                            className="text-end fw-600"
                            style={{ fontSize: 14 }}
                          >
                            {formatIndianNumber(
                              Math.round(
                                +totalAmount +
                                  +totalGST5 +
                                  +totalGST12 +
                                  +totalGST18 +
                                  +totalGST28
                              )
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={7}>
                            <span
                              className="d-block p-0"
                              style={{ fontSize: 8 }}
                            >
                              Amount Chargeable (in words)
                            </span>
                            <span
                              className="d-block fw-600 p-0"
                              style={{
                                fontSize: 12,
                                textTransform: "uppercase",
                              }}
                            >
                              {convertToWords(
                                Math.round(
                                  +totalAmount +
                                    +totalGST5 +
                                    +totalGST12 +
                                    +totalGST18 +
                                    +totalGST28
                                )
                              )}
                            </span>
                          </td>
                          <td className="text-end">E & O.E</td>
                        </tr>
                        {StateID === 1 ? (
                          <>
                            <tr
                              className="text-center fw-600"
                              style={{ fontSize: 13 }}
                            >
                              <th rowSpan={2}>Taxable Value</th>
                              <th colSpan={2}>Central Tax</th>
                              <th colSpan={3}>State Tax</th>
                              <th rowSpan={2} colSpan={2}>
                                Total Tax Amount
                              </th>
                            </tr>
                            <tr
                              className="text-center"
                              style={{ fontSize: 13 }}
                            >
                              <th>Rate</th>
                              <th>Amount</th>
                              <th>Rate</th>
                              <th colSpan={2}>Amount</th>
                            </tr>
                          </>
                        ) : (
                          <>
                            <tr
                              className="text-center"
                              style={{ fontSize: 13 }}
                            >
                              <th rowSpan={2}>Taxable Value</th>
                              <th colSpan={4}>Integrated Tax</th>
                              <th rowSpan={2} colSpan={3}>
                                Total Tax Amount
                              </th>
                            </tr>
                            <tr
                              className="text-center"
                              style={{ fontSize: 13 }}
                            >
                              <th>Rate</th>
                              <th colSpan={3}>Amount</th>
                            </tr>
                          </>
                        )}
                        {StateID === 1 ? (
                          <>
                            {totalGST5 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST5)}</td>
                                <td>2.5 %</td>
                                <td className=" ">
                                  {(+totalGST5 / 2).toFixed(2)}
                                </td>
                                <td>2.5 %</td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST5 / 2)}
                                </td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST5)}
                                </td>
                              </tr>
                            )}
                            {totalGST12 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST12)}</td>
                                <td>6 %</td>
                                <td className=" ">
                                  {(+totalGST12 / 2).toFixed(2)}
                                </td>
                                <td>6 %</td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST12 / 2)}
                                </td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST12)}
                                </td>
                              </tr>
                            )}
                            {totalGST18 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST18)}</td>
                                <td>9 %</td>
                                <td className=" ">
                                  {(+totalGST18 / 2).toFixed(2)}
                                </td>
                                <td>9 %</td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST18 / 2)}
                                </td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST18)}
                                </td>
                              </tr>
                            )}
                            {totalGST28 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST28)}</td>
                                <td>14 %</td>
                                <td className=" ">
                                  {(+totalGST28 / 2).toFixed(2)}
                                </td>
                                <td>14 %</td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST28 / 2)}
                                </td>
                                <td colSpan={2}>
                                  {formatIndianNumber(+totalGST28)}
                                </td>
                              </tr>
                            )}
                          </>
                        ) : (
                          <>
                            {totalGST5 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST5)}</td>
                                <td>5 %</td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST5)}
                                </td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST5)}
                                </td>
                              </tr>
                            )}
                            {totalGST12 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST12)}</td>
                                <td>12 %</td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST12)}
                                </td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST12)}
                                </td>
                              </tr>
                            )}
                            {totalGST18 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST18)}</td>
                                <td>18 %</td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST18)}
                                </td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST18)}
                                </td>
                              </tr>
                            )}
                            {totalGST28 > 0 && (
                              <tr className="text-end">
                                <td>{formatIndianNumber(totalAmountGST28)}</td>
                                <td>28 %</td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST28)}
                                </td>
                                <td colSpan={3}>
                                  {formatIndianNumber(+totalGST28)}
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                        {StateID === 1 ? (
                          <tr
                            className="text-end fw-600"
                            style={{ fontSize: 13 }}
                          >
                            <td>{formatIndianNumber(totalAmount)}</td>
                            <td></td>
                            <td>
                              {formatIndianNumber(
                                +(
                                  (+totalGST5 +
                                    +totalGST12 +
                                    +totalGST18 +
                                    +totalGST28) /
                                  2
                                )
                              )}
                            </td>
                            <td></td>
                            <td colSpan={2}>
                              {formatIndianNumber(
                                +(
                                  (+totalGST5 +
                                    +totalGST12 +
                                    +totalGST18 +
                                    +totalGST28) /
                                  2
                                )
                              )}
                            </td>
                            <td colSpan={2}>
                              {formatIndianNumber(
                                +(
                                  +totalGST5 +
                                  +totalGST12 +
                                  +totalGST18 +
                                  +totalGST28
                                )
                              )}
                            </td>
                          </tr>
                        ) : (
                          <tr
                            className="text-end fw-600"
                            style={{ fontSize: 13 }}
                          >
                            <td>{formatIndianNumber(totalAmount)}</td>
                            <td></td>
                            <td colSpan={3}>
                              {formatIndianNumber(
                                +(
                                  +totalGST5 +
                                  +totalGST12 +
                                  +totalGST18 +
                                  +totalGST28
                                )
                              )}
                            </td>
                            <td colSpan={3}>
                              {formatIndianNumber(
                                +(
                                  +totalGST5 +
                                  +totalGST12 +
                                  +totalGST18 +
                                  +totalGST28
                                )
                              )}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td colSpan={8} style={{ textAlign: "end" }}>
                            <span
                              className="d-block p-0"
                              style={{ fontSize: 8 }}
                            >
                              Tax Amount (in words)
                            </span>
                            <span
                              className="d-block fw-600 p-0"
                              style={{
                                fontSize: 12,
                                textTransform: "uppercase",
                              }}
                            >
                              {convertToWords(
                                +(
                                  +totalGST5 +
                                  +totalGST12 +
                                  +totalGST18 +
                                  +totalGST28
                                )?.toFixed(2)
                              )}
                            </span>
                          </td>
                        </tr>
                      </table>
                    )}
                  </div>
                  <div
                    className="col-12"
                    style={{
                      // textAlign: "end",
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "20px",
                      width: "100%",
                    }}
                  >
                    <Button
                      type="button"
                      fillMode={"solid"}
                      themeColor={"primary"}
                      style={{ marginRight: 4 }}
                      onClick={() =>
                        // setShowPrint(!showPrint)
                        handlePrevious()
                      }
                    >
                      Previous
                    </Button>
                    <ButtonWithLoading
                      label="Place Order"
                      type="submit"
                      onClick={() => setSubmitAction("submit")}
                      loading={submitAction === "submit" && loading}
                      disabled={submitAction === "submit" && loading}
                    />
                  </div>
                </div>
              </div>
            )}
            <OrderChangeWatcher formRenderProps={formRenderProps} />
          </FormElement>
        )}
      />
    </div>
  );
};

export default CreateRetailerSalesOrder;
